enum TipoBuscaVenda {
    Venda = 0,
    Cliente = 1,
    Manipulacao = 2,
    Paciente = 3,
}

export default TipoBuscaVenda;
